import { render, staticRenderFns } from "./SpendPlan.vue?vue&type=template&id=48d99c29&"
import script from "./SpendPlan.vue?vue&type=script&lang=js&"
export * from "./SpendPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports